import { graphql, useStaticQuery } from "gatsby";

export const useSiteMetadata = () => {
  const { site } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          description
          site_url
          nav_title
          sec_nav_title
          title
          author
          theme
          brochures {
            brochure_dl
            travel_dl
          }
          social_media {
            blog
            facebook
            instagram
            linkedin
            tiktok
            twitter
            whatsapp
            youtube
            google_scholar
          }
          site_locales {
            au {
              domain
              currency
              currency_symbol
              lang_code
              lang
              country
              contact_details {
                address
                calling_from_label
                calling_from_value
                international
                google_map_link
                office_hours
                office_closures
              }
              eft_details {
                bank
                account_name
                account_number
                swift_code
                bank_address
              }
            }
            can {
              domain
              currency
              currency_symbol
              lang_code
              lang
              country
              contact_details {
                address
                calling_from_label
                calling_from_value
                international
                google_map_link
                office_hours
                office_closures
              }
              eft_details {
                bank
                account_name
                account_number
                routing_number
                swift_code
                bank_address
              }
            }
            en {
              domain
              currency
              currency_symbol
              lang_code
              lang
              country
              contact_details {
                address
                calling_from_label
                calling_from_value
                international
                google_map_link
                office_hours
                office_closures
              }
              eft_details {
                bank
                account_name
                account_number
                sort_code
                iban
                swift_code
                bank_address
              }
            }
            ie {
              domain
              currency
              currency_symbol
              lang_code
              lang
              country
              contact_details {
                address
                calling_from_label
                calling_from_value
                international
                google_map_link
                office_hours
                office_closures
              }
              eft_details {
                bank
                account_name
                account_number
                sort_code
                iban
                swift_code
                bank_address
              }
            }
            us {
              domain
              currency
              currency_symbol
              lang_code
              lang
              country
              contact_details {
                address
                calling_from_label
                calling_from_value
                international
                google_map_link
                office_hours
                office_closures
              }
              eft_details {
                bank
                account_name
                account_number
                routing_number
                swift_code
                bank_address
              }
            }
            za {
              domain
              currency
              currency_symbol
              lang_code
              lang
              country
              contact_details {
                address
                calling_from_label
                calling_from_value
                international
                google_map_link
                office_hours
                office_closures
              }
              eft_details {
                bank
                account_name
                account_number
                branch
                branch_code
                bank_address
              }
            }
          }
        }
      }
    }
  `);

  return site;
};
